// Marketing · Contactos (montado en /marketing/contactos/*): lista de contactos con
// segmentos y acciones masivas, y listas de destinatarios (estáticas y segmentos).
import type { JSX } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { ContactsPage } from "./contacts/ContactsPage.tsx";
import { ListDetail } from "./contacts/ListDetail.tsx";
import { ListsPage } from "./contacts/ListsPage.tsx";

const SUB = [
  { to: "/marketing/contactos", label: "Contactos", end: true },
  { to: "/marketing/contactos/listas", label: "Listas y segmentos", end: false },
];

export function MktContacts(): JSX.Element {
  return (
    <div className="space-y-3">
      <div className="inline-flex rounded-lg border border-line p-0.5 bg-surface">
        {SUB.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end}
            className={({ isActive }) => `px-3 py-1.5 text-sm rounded-md transition-colors ${isActive ? "bg-primary-soft text-primary dark:text-ink font-medium" : "text-ink-secondary hover:text-ink"}`}>
            {t.label}
          </NavLink>
        ))}
      </div>
      <Routes>
        <Route index element={<ContactsPage />} />
        <Route path="listas" element={<ListsPage />} />
        <Route path="listas/:id" element={<ListDetail />} />
      </Routes>
    </div>
  );
}
